import { render, staticRenderFns } from "./resultkaruniarohani.vue?vue&type=template&id=32c41852&"
import script from "./resultkaruniarohani.vue?vue&type=script&lang=js&"
export * from "./resultkaruniarohani.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports